import { authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import { useEffect } from "react";
import useSWR from "swr";

type useTotalWithdrawalsResponse = {
  totalWithdrawnPoints: string;
};

const fetcher = (url: string): Promise<useTotalWithdrawalsResponse> => {
  const headers = authHeader.getOrThrow();
  return romanApi.get<useTotalWithdrawalsResponse>(url, undefined, { headers });
};

export const useTotalWithdrawals = (handleError: (err: RomanApiError) => void, isDemoMode: boolean) => {
  const demoData: useTotalWithdrawalsResponse = {
    totalWithdrawnPoints: "10000",
  };

  const {
    data: apiData,
    isLoading: isApiLoading,
    error: apiError,
  } = useSWR<useTotalWithdrawalsResponse, RomanApiError>("/point-withdrawals/total", fetcher);

  useEffect(() => {
    if (apiError && !isDemoMode) {
      handleError(apiError);
    }
  }, [apiError, handleError, isDemoMode]);

  return {
    data: isDemoMode ? demoData : apiData,
    isLoading: isDemoMode ? false : isApiLoading,
  };
};
